<div class="source-team-tab-wrapper">
  <div class='source-teams-wrapper'>

    <div class='search'>
      <mat-form-field class="source-teams-search" appearance="fill">
        <mat-label>{{ "system.search" | translate }}</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input [formControl]="searchControl" matInput/>
        <button *ngIf="isSearchValue" (click)="clearFilter()" mat-icon-button matSuffix matTooltip="Clear"
                class="clear-button">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="team-table-wrapper">
      <mat-table [dataSource]='dataSource'>
        <ng-container matColumnDef='IsEnabled'>
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef='let team'>
            <i
              class='material-icons enable-disable-icon'
              (click)='changeEnableState(team)'
              [ngClass]="{ 'green-color': team.IsEnabled, 'red-color': !team.IsEnabled }"
            >
              {{ team.IsEnabled ? 'done' : 'close' }}
            </i>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef='LogoUrl'>
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef='let team'>
            <img class='logo-image' [src]='team.LogoUrl' alt=''>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef='Name'>
          <mat-header-cell *matHeaderCellDef>{{ 'sourceTeamsTab.Name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef='let team'>
            <a [href]='getTeamEditLink(team)'>
              {{ team.Name }}
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef='Slug'>
          <mat-header-cell *matHeaderCellDef>{{ 'sourceTeamsTab.Identifier' | translate }}</mat-header-cell>
          <mat-cell *matCellDef='let team'>
            <a [href]='getTeamEditLink(team)'>
              {{ team.Slug }}
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef='CreatedAtUtc'>
          <mat-header-cell *matHeaderCellDef>{{ 'sourceTeamsTab.Created' | translate }}</mat-header-cell>
          <mat-cell *matCellDef='let team'>
            {{ team.CreatedAtUtc | date: 'yyyy-MM-dd' }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef='displayedColumns'></mat-header-row>
        <mat-row *matRowDef='let row; columns: displayedColumns;'></mat-row>
      </mat-table>
    </div>

    <mat-paginator [pageSizeOptions]='[5, 10, 25, 100]' [pageSize]='25'
                   aria-label='Select page of users'></mat-paginator>
  </div>
</div>
